import React, { useContext, useEffect } from "react";
import { Box, Grid } from "@mui/material";
import PageHeader from "../../../components/PageHeader";
import { ShoppingTracking } from "../../../components/PackageTracking";
import SidebarContext from "../../../context/SidebarContext";
import SimpleBar from "simplebar-react";
import PackagesShopping from "./PackagesShopping";
import AllUsersShopping from "./AllUsersShoppping";
import OrderHistory from "../../../components/common/History/OrderHistory";
import OrderChats from "../../../components/common/orderChat/OrderChats";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveComponent,
  setPackages,
  setRequests,
  setSelectedPackage,
  setSelectedRequest,
  setActiveItem,
} from "../../../store/commonSlice";
import { useShoppingFilters } from "./hooks/useShoppingFilters";
import { useShoppingData } from "./hooks/useShoppingData";
import { formatDate } from "./utils/shoppingUtils";
import { getShelfShoppingPackages } from "../../../helper/functions";

function ShoppingRequest() {
  const dispatch = useDispatch();
  const { selectedPackage: packageActiveData, activeComponent } = useSelector(
    (state) => state.common
  );
  const { open } = useContext(SidebarContext);

  // Use custom hooks
  const { selectedFilters, filterOptions, changeFilterHandler } =
    useShoppingFilters();
  const isLoading = useShoppingData(selectedFilters);

  // Handlers
  const chatClickHandler = async (e, id, item) => {
    e.stopPropagation();
    dispatch(setActiveComponent("Chats"));
    dispatch(setSelectedPackage(item));
  };

  const historyClickHandler = async (id, item, e) => {
    e.stopPropagation();
    dispatch(setActiveComponent("History"));
    const data = await getShelfShoppingPackages([
      { key: "__name__", operator: "==", value: id },
    ]);
    if (data?.length > 0) {
      dispatch(setSelectedPackage(data[0]));
    }
  };

  const userClickHandler = async (id, item) => {
    dispatch(setActiveComponent("Actions"));
    console.log(item, activeComponent, "details in userClickHandler");
    dispatch(setSelectedRequest(item));
    dispatch(setSelectedPackage(null));
    dispatch(setActiveItem(null));
  };

  const packageClickHandler = async (id, item) => {
    dispatch(setActiveComponent("Actions"));
    dispatch(setSelectedPackage(item));
    dispatch(setActiveItem(null));
  };

  const closeHistoryHandler = () => {
    dispatch(setActiveComponent("Actions"));
  };

  // Handle filter changes with cleanup
  const handleFilterChange = (filter) => {
    changeFilterHandler(filter);
    dispatch(setSelectedRequest(null));
    dispatch(setSelectedPackage(null));
  };

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(setSelectedPackage(null));
      dispatch(setSelectedRequest(null));
      dispatch(setPackages([]));
      dispatch(setRequests([]));
    };
  }, [dispatch]);

  // Calculate active step based on package tracking status
  const activeStep =
    packageActiveData?.packageTrackingStatus === "Ordered"
      ? 2
      : packageActiveData?.packageTrackingStatus === "Received"
        ? 3
        : packageActiveData?.packageTrackingStatus === "Done"
          ? 4
          : 1;

  // Steps configuration
  const steps = [
    {
      label: "Requested",
      date: packageActiveData?.requestedAt
        ? formatDate(packageActiveData.requestedAt)
        : "-",
    },
    {
      label: "Ordered",
      date: packageActiveData?.orderedAt
        ? formatDate(packageActiveData.orderedAt)
        : "-",
    },
    {
      label: "Received",
      date: packageActiveData?.receivedAt
        ? formatDate(packageActiveData.receivedAt)
        : "",
    },
    { label: "Done", date: "-" },
  ];

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <PageHeader
        pageTitle={"Shoppings"}
        selectedFilters={selectedFilters}
        filterOptions={filterOptions}
        changeFilterHandler={handleFilterChange}
      />
      <Box
        sx={{
          flex: 1,
          backgroundColor: "white",
          borderTop: "1px solid #E5E5E8",
        }}
      >
        <Grid
          container
          spacing={0}
          sx={{
            width: open === false ? "calc(97vw - 80px)" : "calc(97vw - 240px)",
          }}
        >
          <Grid item sm={12} md={3}>
            <AllUsersShopping
              userClickHandler={userClickHandler}
              selectedFilters={selectedFilters}
              loading={isLoading}
            />
          </Grid>
          <Grid
            item
            sm={12}
            md={3}
            sx={{
              borderLeft: "1px solid #E5E5E8",
              borderRight: "1px solid #E5E5E8",
            }}
          >
            <PackagesShopping
              packageClickHandler={packageClickHandler}
              historyClickHandler={historyClickHandler}
              chatClickHandler={chatClickHandler}
              selectedFilters={selectedFilters}
            />
          </Grid>
          <Grid item sm={12} md={6}>
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "88vh" }}
              className="custom-scrollbar"
            >
              {activeComponent === "Chats" && (
                <OrderChats
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "History" && (
                <OrderHistory
                  closeHistory={closeHistoryHandler}
                />
              )}
              {activeComponent === "Actions" && (
                <ShoppingTracking
                  steps={steps}
                  activeStep={activeStep}
                />
              )}
            </SimpleBar>
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default ShoppingRequest;
